import React from "react";

export const Context = React.createContext<{
  authorized: boolean;
  setAuthorized: (value: boolean) => void;
}>({ authorized: false, setAuthorized: () => {} });
